// extracted by mini-css-extract-plugin
export default {"wrapper":"Fo-z","reviewFormSuccess":"Go-z","header":"Ho-z","message":"Io-z","paragraph":"Jo-z","lottieContainer":"Ko-z"};